export const ONBOARDING_FEATURE_FLAG_NAME = "onboarding" as const

export const SUPPLIER_ONBOARDING_ENTRY_PATH = "/supplier/onboarding" as const

export const SUPPLIER_DEFAULT_HOME_PATH =
  "/supplier/requests/traceability" as const

export const BLOCKED_ONBOARDING_REDIRECT_PATH = "/login" as const
